import useGetDatabaseInitialValues from './useGetDatabaseInitialValues'

export default useGetDatabaseInitialValues
